import { Capacitor } from "@capacitor/core";

/** true uniquement dans l'app native Capacitor (iOS/Android), false dans un navigateur web. */
export const isNativeApp = Capacitor.isNativePlatform();

/** true uniquement dans l'app iOS native (bouton Apple, etc.). */
export const isIOSApp = isNativeApp && Capacitor.getPlatform() === "ios";
